import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TicketsApiService } from '../services/tickets-api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-tickets-description-new',
  templateUrl: './tickets-description.component.html',
  styleUrls: ['./tickets-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TicketsDescriptionComponent {
  @Input() ticket;

  loading = true;

  gp_text = '';

  constructor(private ticketsApiService: TicketsApiService) {}

  handleShow(ticketNumber: number) {
    this.loading = true;

    this.ticketsApiService
      .getTicket(ticketNumber)
      .pipe(
        tap((response) => {
          this.gp_text = response.data.gp_text;
          this.loading = false;
        })
      )
      .subscribe();
  }

  handleHide() {
    this.loading = false;
  }

  truncateString(originalString: string, maxLength: number): string {
    return originalString.length > maxLength ? originalString.substring(0, maxLength) + '...' : originalString;
  }
}
